var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "83px",
    viewBox: "0 0 83 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_CompanyDESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homeowner-View---Delete-Module",
    transform: "translate(-681.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(681.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#FFCC00"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    cx: 41.5,
    cy: 41.5,
    r: 41.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "baseline-delete_forever-24px",
    transform: "translate(24.000000, 19.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55555556,40.8888889 C2.55555556,43.7 4.85555556,46 7.66666667,46 L28.1111111,46 C30.9222222,46 33.2222222,43.7 33.2222222,40.8888889 L33.2222222,10.2222222 L2.55555556,10.2222222 L2.55555556,40.8888889 Z M8.84222222,22.6933333 L12.4455556,19.09 L17.8888889,24.5077778 L23.3066667,19.09 L26.91,22.6933333 L21.4922222,28.1111111 L26.91,33.5288889 L23.3066667,37.1322222 L17.8888889,31.7144444 L12.4711111,37.1322222 L8.86777778,33.5288889 L14.2855556,28.1111111 L8.84222222,22.6933333 Z M26.8333333,2.55555556 L24.2777778,0 L11.5,0 L8.94444444,2.55555556 L0,2.55555556 L0,7.66666667 L35.7777778,7.66666667 L35.7777778,2.55555556 L26.8333333,2.55555556 Z",
    id: "Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash_yellow.f528e05c260fb92a0697422263f3f2a5.svg";